export const config = {
  apiKey: "AIzaSyBoM-jTeYfdM5YEnqzef4p40ERcP4dm-p8",
  authDomain: "faker-be925.firebaseapp.com",
  databaseURL: "https://faker-be925.firebaseio.com",
  projectId: "faker-be925",
  storageBucket: "faker-be925.appspot.com",
  messagingSenderId: "148225881998"
}



// WEBPACK FOOTER //
// ./src/firebase/config.js